import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"
import { menuItems } from "./Menu"
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const simpleBarRef = useRef()
  const userData = JSON.parse(localStorage.getItem("userData"))

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show")
        const parent3 = parent2.parentElement

        if (parent3) {
          parent3.classList.add("mm-active")
          parent3.childNodes[0].classList.add("mm-active")
          const parent4 = parent3.parentElement
          if (parent4) {
            parent4.classList.add("mm-show")
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show")
              parent5.childNodes[0].classList.add("mm-active")
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active")
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement
            if (parent4) {
              parent4.classList.remove("mm-show")
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show")
                parent5.childNodes[0].classList.remove("mm-active")
              }
            }
          }
        }
      }
    }
  }

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [props.router.location.pathname, activateParentDropdown])

  useEffect(() => {
    if (simpleBarRef.current?.recalculate) {
      simpleBarRef.current.recalculate()
    }
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item && simpleBarRef.current?.getScrollElement) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        simpleBarRef.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const helperFunction = (permissions, permissionName) => {
    if (!permissions || !Array.isArray(permissions)) {
      return false
    }
    return permissions.some(permission => permission?.permissionName === permissionName)
  }

  const handleSubMenuToggle = event => {
    // Submenu parents should only expand/collapse the menu.
    event.preventDefault()
  }

  const renderMenuItem = (item) => {
    const hasPermission = userData.role === 'admin' || helperFunction(userData.permission?.permission, item.permission)

    if (!hasPermission) return null

    if (item.isSubMenu) {
      return (
        <li key={item.id}>
          <Link
            to={props.router.location.pathname}
            className="has-arrow waves-effect"
            onClick={handleSubMenuToggle}
          >
            <i className={item.icon}></i>
            <span>{props.t(item.label)}</span>
          </Link>
          <ul className="sub-menu">
            {item.subItems.map(subItem => {
              const hasSubPermission = userData.role === 'admin' ||
                helperFunction(userData.permission?.permission, subItem.permission)

              if (!hasSubPermission) return null
              if (subItem.isSubMenu) {
                return renderMenuItem(subItem)
              }

              return (
                <li key={subItem.id}>
                  <Link to={subItem.link}>
                    <i className={subItem.icon}></i>
                    {props.t(subItem.label)}
                  </Link>
                </li>
              )
            })}
          </ul>
        </li>
      )
    }

    return (
      <li key={item.id}>
        <Link to={item.link} className="waves-effect">
          <i className={item.icon}></i>
          <span>{props.t(item.label)}</span>
        </Link>
      </li>
    )
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={simpleBarRef}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            {menuItems.map(item => renderMenuItem(item))}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
